import { useState } from 'react';
import PropTypes from 'prop-types';

// Other
import './styles.css'; 

const Tooltip = ({ text, children }) => {

    const [showTooltip, setShowTooltip] = useState(false);

    return (
        <div className="Tooltip__container" onMouseEnter={() => {setShowTooltip(true)}} onMouseLeave={() => {setShowTooltip(false)}}>
            {children}

            {showTooltip && 
                <div className="Tooltip">
                    <div className="Tooltip__arrow"></div>
                    <div className="Tooltip__content">{text}</div>
                </div>
            }
        </div>
    );
};

Tooltip.propTypes = {
    text: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};

Tooltip.defaultProps = {
    text: '',
    children: null
}

export default Tooltip;
